export * from './access.model';
export * from './auth.service';
export * from './auth-guard.service';
export * from './message-broker.service';
export * from './role-guard.service';
export * from './pending-changes.guard';
export * from './user-info.model';
export * from './error.model';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/index.ts